<template>
    <div class='HomePageContainer'>

        <modals-container/>
      <transition
          name="fade"
          mode="out-in"
      >
        <div style="height: 100%" class='content'>
            <div class="PageHeader">
                <div class="PageHeaderRollsRoyceLogo"></div>
                <div class="PageHeaderTitleContainer">Process Standardisation</div>

                <div class='PageHeaderButtonContainer' ref='login_button'>
                    <button class='AcronymsButton' :class="{ AcronymsOnState: acronymsState }" @click="showAcronyms"></button>
                    <button class='NavBackButton DisableButton HideMe'></button>
                </div>
            </div>

            <video autoplay muted loop playsinline class="HomeVideoContainer FullSize HomePoster">
                <source src="assets/animations/supply_chain_loop.mp4" type="video/mp4">
            </video>

            <div class="homeContent">

                <div class="HomeBtnContainer">
                    <ButtonComponent :icon="this.iconService.icons.Why" text="Why" link="why" font-size="28px"></ButtonComponent>
                    <ButtonComponent :icon="this.iconService.icons.What" text="What" link="what"  font-size="28px"></ButtonComponent>
                    <ButtonComponent :icon="this.iconService.icons.Tools" text="Tools" link="tools"  font-size="28px"></ButtonComponent>
                </div>
            </div>


        </div>
      </transition>
    </div>

</template>

<script>
    import AcronymsModal from '../modals/AcronymsModal.vue';
    import ButtonComponent from "../ui/ButtonComponent";
    import iconService from "../../services/iconService";

    export default {
        data () {
            return {
                acronymsState: false,
                welcomeState: true,
                iconService: iconService
            }
        },

        created: function() {

        },

        methods: {

            showAcronyms() {
                // Open Acronyms Modal 'LightOut' Box
                this.$modal.show(AcronymsModal, {}, {
                    width: "100%",
                    height: "auto"
                },{
                    'before-close': () => { this.acronymsState = !this.acronymsState }
                });

                this.acronymsState = !this.acronymsState
            },
        },
        components:
            {
                ButtonComponent
            }
    }
</script>
